import logo from '../../Assets/svg/logo_color.svg'
// SignInCard component
export const SignInCard = ({containerClass, cardClass, onSigninClick}) => (
    <div className={`d-flex align-items-center justify-content-center ${containerClass}`}>
        <div className={`card sign-in-card ${cardClass}`}>
            <div className="card-body p-5">
                <div className='text-center'><img src={logo} alt="Company Logo" className="company-logo" /></div>
                <h5 className="card-title text-center">Select an option to sign in</h5>
                {   /* Add your form and sign in button here */}
                <div className='w-100 d-flex justify-content-center mt-5'>
                <button className="btn btn-tertiary text-light w-50" onClick={onSigninClick}>Sign In With Microsoft</button>
                </div>
            </div>
        </div>
    </div>
);